<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-02 16:37:19
-->
<template>
  <el-drawer
    title="分组管理"
    :visible.sync="visibleTwo"
    @closed="close"
    size="540px"
    :with-header="true"
    class="box"
  >
  <a-spin :spinning="loading" class="loading"/>
    <div class="table-box">
        
      <el-table class="table" :data="grouplist">
          
        <el-table-column prop="groupName" label="分组名称">
            
          <template slot-scope="scope">
            <div class="default"  v-if="scope.$index == 0">{{scope.row.groupName}}</div>
            <el-input
              v-if="scope.$index != 0"
              :disabled="!scope.row.isNew && !scope.row.isEdit"
              style="width: 90%"
              v-model="scope.row.groupName"
              placeholder="请输入分组名称"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序">
          <template slot-scope="scope">
            <div  v-if="scope.$index != 0" class="sort">
              <div class="sort-box">
                  <div @click="subtractSort(scope.row.id)" v-if="!scope.row.isNew && codeData.indexOf('209') != -1" class="sort-two">
                       <i    class="ri-arrow-down-line"></i>
                  </div>
              </div>
              <input
                disabled="true"
                v-model="scope.row.sort"
                class="sort-input"
              />
               <div  class="sort-box-two">
                    <div class="sort-two" @click="addSort(scope.row.id)" v-if="!scope.row.isNew && codeData.indexOf('208') != -1">
                        <i   class="ri-arrow-up-line"></i>
                    </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template  v-if="scope.$index != 0"  slot-scope="scope">
            <a
              v-if="!scope.row.isEdit && !scope.row.isNew && codeData.indexOf('152') != -1"
              @click="edit(scope.row, scope.$index)"
              style="margin-right: 20px"
              class="btn"
              >编辑</a
            >
            <a
              v-if="(scope.row.isNew || scope.row.isEdit) && codeData.indexOf('152') != -1"
              @click="saveGroup(scope.row,scope.$index)"
              style="margin-right: 20px"
              class="btn"
              >保存</a
            >
            <a
              v-if="codeData.indexOf('153') != -1"
              @click="deleteFn(scope.row, scope.$index)"
              style="color: red"
              class="btn"
              >删除</a
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="demo-ruleForm">
      <div class="bottom">
        <div class="form-bottom">
          <el-button
           v-if="codeData.indexOf('151') != -1"
            @click="addAdminFn"
            size="medium"
            type="primary"
            >新增分组</el-button>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { message } from 'ant-design-vue';
import {variableGrouplist,AddVariableGroup,updateVariableGroup,variableGroupDel,groupUp,groupDown} from './custom_variables.js';
export default {
    data() {
        return {
            grouplist: [],
            newGrouplist:[],//新增的分组名称
            editable:true,
            loading:false,
            codeData:[],
            visibleTwo:false,
        };
    },
    props: {
        visible:{
        type:Boolean,
        default:false,
        }
    },
    watch:{
      visible(val){
        this.visibleTwo = this.visible;
        if(val){
           this.getGrouplist()
        }
      }
    },
    created(){
        
    },
    mounted(){
        this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    },
    methods: {
        getGrouplist(){
            const _this = this
            _this.loading = true
            variableGrouplist({siteId: sessionStorage.getItem('siteId')}).then(res=>{
                if(res.code==0){
                    this.grouplist = res.data
                    _this.grouplist = _this.grouplist.concat(_this.newGrouplist)
                    _this.loading = false
                }
            })
        },
        // 排序增加
        addSort(id) {
            this.loading = true
            groupUp({id}).then(res=>{
                if(res.code==0){
                    this.getGrouplist()
                }
            })
        },
        // 排序减少
        subtractSort(id) {
            groupDown({id}).then(res=>{
                if(res.code==0){
                    this.getGrouplist()
                }
            })
        },
        close() {
            this.$emit("close");
        },
        deleteFn(item, index) {
            const _this = this
            if (item.isNew) {
                _this.grouplist.splice(index, 1);
                let arr = []
                _this.newGrouplist.map(newitem=>{
                    if(newitem.groupName != item.groupName){
                        arr.push(newitem)
                    }
                })
                _this.newGrouplist = arr
            } else {
                variableGroupDel({id:item.id}).then(res=>{
                    if(res.code==0){
                        message.success(res.msg)
                        _this.getGrouplist()
                    }
                })
            }
        },
        //新增变量分组
        addAdminFn() {
            if(this.newGrouplist.length>0 || this.editable == false){
                return
            }
            this.newGrouplist.push({
                groupName: "",
                sort: this.grouplist.length,
                isNew: true,
            });
            this.grouplist.push({
                groupName: "",
                sort: this.grouplist.length,
                isNew: true,
            });
        },
        //保存新增变量分组
        saveGroup(item,index) {
            const _this = this
            if(!item.groupName){
                message.error('请输入分组名称')
                return
            }
            if(item.isNew){
                AddVariableGroup({...item,siteId:sessionStorage.getItem('siteId')}).then(res=>{
                    if(res.code == 0){
                        _this.grouplist[index].isNew = false
                        // let arr = []
                        // _this.newGrouplist.map(newitem=>{
                        //     if(newitem.groupName != item.groupName){
                        //         arr.push(newitem)
                        //     }
                        // })
                        _this.newGrouplist = []
                        _this.editable = true
                        _this.getGrouplist()
                    }
                })
            }else{
                updateVariableGroup({...item,siteId:sessionStorage.getItem('siteId')}).then(res=>{
                    if(res.code == 0){
                        _this.grouplist[index].isEdit = false
                        _this.editable = true
                        _this.getGrouplist()
                    }
                })
            }
        },
        submit() {},
        edit(item, index) {
            if(!this.editable)return
            let array = this.grouplist;
            array[index].isEdit = true;
            this.grouplist = JSON.parse(JSON.stringify(array))
            this.editable = false
        },
    },
    created() {
    },
};
</script>

<style lang="less" scoped>
.loading{
    position: absolute;
    top: 50%;
    left: 40%;
}
.table-box {
  padding: 0 24px;

}
/deep/ .el-table {
  border: solid 1px #dcdfe6;
  border-radius: 5px;
  border-bottom: none;
}
/deep/ .el-table__body {
  color: #000;
  font-weight: 500;
}
/deep/ .has-gutter {
  color: #000;
  font-weight: 800;
}
/deep/ .el-table__header {
  th {
    background: #f7f7f7 !important;
    height: 60px;
  }
}
/deep/ .el-table__header {
  th:nth-of-type(1) {
    padding-left: 14px;
  }
}
/deep/ .el-table__header {
  th:nth-of-type(2) {
    padding-left: 24px;
  }
}
/deep/ .el-drawer__header {
  border-bottom: solid 2px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
  background: #fff;
}
.bottom {
  position: absolute;
  bottom: 0;
  height: 80px;
  border-top: solid 2px #e5e7ec;
  width: 100%;
   background: #fff;
   z-index: 999;
  .form-bottom {
    margin-top: 22px;
    margin-right: 24px;
    padding-left: 24px;
    display: flex;
    justify-content: space-between;
  }
}
.add-img {
  margin-top: -2px;
  margin-right: 3px;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
/deep/ .el-input__inner {
  height: 34px;
  margin-left: 14px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
.sort-input {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
}
.img {
  cursor: pointer;
}
.default{
    margin-left:14px;
    padding:5px 0px;
    font-size: 14px;
}
/deep/ .el-table__body-wrapper{ 
    max-height: 630px !important;
    overflow: hidden;
    overflow-y: auto;
}
.table-box{
    margin-bottom: 100px;
}
.el-button--primary {
  background: #176de6;
}
.sort-two{
   display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500 !important;
  cursor: pointer;
}
/deep/ tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td{
   background: #fafafa !important;
}
</style>